__turbopack_context__.v({
  "actions": "Dialog-module__mohuda__actions",
  "actionsInline": "Dialog-module__mohuda__actionsInline",
  "actionsMain": "Dialog-module__mohuda__actionsMain",
  "actionsSecondary": "Dialog-module__mohuda__actionsSecondary",
  "actionsSticky": "Dialog-module__mohuda__actionsSticky",
  "closeIconDesktop": "Dialog-module__mohuda__closeIconDesktop",
  "closeIconMobile": "Dialog-module__mohuda__closeIconMobile",
  "content": "Dialog-module__mohuda__content",
  "dialog": "Dialog-module__mohuda__dialog",
  "dragHandle": "Dialog-module__mohuda__dragHandle",
  "header": "Dialog-module__mohuda__header",
  "headerBar": "Dialog-module__mohuda__headerBar",
  "headerBarDraggable": "Dialog-module__mohuda__headerBarDraggable",
  "placeholder": "Dialog-module__mohuda__placeholder",
});
